export function getCookie (name) {
    return DM.Utils.getCookie(name);
}

export function setCookie(name, value, days) {
    return DM.Utils.setCookie(name, value, days);
}

export function deleteCookie (name) {
    return DM.Utils.deleteCookie(name);
}
